import { render, staticRenderFns } from "./ListadoAdicionales.vue?vue&type=template&id=66848fd4&scoped=true"
import script from "./ListadoAdicionales.vue?vue&type=script&lang=js"
export * from "./ListadoAdicionales.vue?vue&type=script&lang=js"
import style0 from "./ListadoAdicionales.vue?vue&type=style&index=0&id=66848fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66848fd4",
  null
  
)

export default component.exports